import React, { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import Nav from "../../../Components/base/nav";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import RichTextEditor from "../../../Components/RichTextEditor"; // Ensure this import is correct
import ChooseImage from "../../../Components/Modal/ChooseImage";
import Sidebar from "../../../Components/base/sidebar";
import { Button } from "react-bootstrap";
import { BsEye, BsTrash } from "react-icons/bs";
import ActionBar from "../../../Components/Button/ActionBar";
import StoryDetails from "../../../Components/Forms/StoryDetails";
import Delete from "../../../Components/Button/Delete";
import UpdateTicketForm from "../../../Components/Forms/UpdateTicketForm";
import SEOForm from "../../../Components/Forms/SEOForm";

export default function UpdateTicket() {
  const location = useLocation();
  const id = location.state && location.state.ticket_id;
  const [ticket_group_code, setTicketGroupCode] = useState("");
  const [ticket_notes, setTicketNotes] = useState("");
  const [item, setItem] = useState<any | null>(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSaved, setIsSaved] = useState(false);
  const [role, setRole] = useState<string | null>(null);

  useEffect(() => {
    if (id) {
      fetchItem(id);
    }
  }, [id]);

  const handleTicketGroupCodeChange = (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    setTicketGroupCode(e.target.value);
  };

  const handleTicketNotesChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setTicketNotes(e.target.value);
  };

  const navigate = useNavigate();

  const fetchItem = async (id: number) => {
    try {
      const authToken = localStorage.getItem("authToken");
      const response = await axios.get(
        `https://stagingbackend.pulp.ph/api/v1/pulpliveworld/ticket/${id}`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      ); // Fetch item based on ID
      const ticket = response.data.ticket;
      if (ticket) {
        const { ticket_group_code, ticket_notes } = ticket;
        setItem(ticket);
        setTicketGroupCode(ticket_group_code);
        setTicketNotes(ticket_notes);
      }
    } catch (error) {
      console.error("Error fetching item:", error);
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);

    const formData = new FormData();
    formData.append("ticket_group_code", ticket_group_code);
    formData.append("ticket_notes", ticket_notes);

    try {
      const authToken = localStorage.getItem("authToken");
      if (!authToken) {
        // Handle the case where authToken is not available
        alert("Authentication token not found!");
        setIsSubmitting(false);
        return;
      }

      await axios.post(
        `https://stagingbackend.pulp.ph/api/v1/pulpliveworld/ticket/${id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      alert("Content Submitted Successfully !!"); // Handle success (e.g., show a success message or redirect)
      navigate("/view/post/ticket");
    } catch (error) {
      console.error("There was an error submitting the form!", error);
      alert(`There was an error submitting the form!, ${error}`);
      // Handle error (e.g., show an error message)
    } finally {
      setTimeout(() => {
        setIsSubmitting(false);
      }, 3000);
    }
  };

  // const handleSaveDraft = async (e: React.FormEvent) => {
  //     e.preventDefault();
  //     setIsSaved(true);

  //     const formData = new FormData();
  //     formData.append('category', category);
  //     formData.append('sub_category', sub_category);
  //     formData.append('title', title);
  //     formData.append('body', body);
  //     formData.append('seo_title', seo_title);
  //     formData.append('description', description);
  //     formData.append('sub_head', sub_head);
  //     formData.append('photo_by', photo_by);
  //     if (image) {
  //         formData.append('image', image);
  //     }

  //     try {
  //         const authToken = localStorage.getItem('authToken');
  //         if (!authToken) {
  //             // Handle the case where authToken is not available
  //             alert('Authentication token not found!');
  //             setIsSubmitting(false);
  //             return;
  //         }

  //         await axios.post(`https://cdn.pulp.ph/api/v1/longStory/save/${id}`, formData, {
  //             headers: {
  //                 'Content-Type': 'multipart/form-data',
  //                 Authorization: `Bearer ${authToken}`,
  //             }
  //         });
  //         alert('Draft Saved Successfully !!'); // Handle success (e.g., show a success message or redirect)
  //         navigate('/view/post/ticket');
  //     } catch (error) {
  //         console.error('There was an error submitting the form!', error);
  //         alert(`There was an error submitting the form!, ${error}`);
  //         // Handle error (e.g., show an error message)
  //     } finally {
  //         setTimeout(() => {
  //             setIsSaved(false);
  //         }, 3000);
  //     }
  // };

  const handleDelete = async () => {
    try {
      const authToken = localStorage.getItem("authToken");
      if (!authToken) {
        alert("Authentication token not found!");
        return;
      }

      const confirmDelete = window.confirm(
        "Are you sure you want to delete this content?"
      );
      if (!confirmDelete) {
        return; // If user cancels, do nothing
      }

      if (id) {
        await axios.delete(
          `https://stagingbackend.pulp.ph/api/v1/pulpliveworld/ticket/${id}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            },
          }
        );
      }
      alert("Content Deleted Successfully !!");
      navigate("/view/post/ticket");
    } catch (error) {
      console.error("There was an error deleting the content!", error);
      alert(`There was an error deleting the content!, ${error}`);
    }
  };

  const handleViewLongStory = () => {
    window.open(
      `https://pulpmagazine.pulp.ph/article/long_story/${id}`,
      "_blank"
    );
  };

  useEffect(() => {
    const storedRole = localStorage.getItem("role");
    setRole(storedRole);
  }, []);

  return (
    <>
      <div className="w-full">
        <div className="Dashboard-container flex place-content-between">
          <h1 className="mt-5 font-semibold">Ticket Price Note Editor</h1>
          <ActionBar
            role={role}
            onSubmit={handleSubmit}
            onView={handleViewLongStory}
            isSubmitting={isSubmitting}
            isSaved={isSubmitting}
          />
        </div>
        <div className="container mt-5 pt-5 px-4 rounded bg-white">
          <UpdateTicketForm
            ticket_group_code={ticket_group_code}
            ticket_notes={ticket_notes}
            onTicketGroupCodeChange={handleTicketGroupCodeChange}
            onTicketNotesChange={handleTicketNotesChange}
          />

          <Delete onDelete={handleDelete} />
        </div>
      </div>
    </>
  );
}
